// import React, { useRef } from 'react';
import styles from './MainContainerLeftControl.module.scss';
import Aside from '../Aside/Aside';
import classnames from 'classnames';

const MainContainerLeftControl = ({ children, widthAside, data, logoPosition = '', logoColor = '#00405b' }) => {
  return (
    <div
      className={classnames(logoPosition ? [styles.leftControl, styles.absolute] : [styles.leftControl])}
      id="container">
      <div className={styles.aside}>
        <Aside widthAside={widthAside} data={data} logoPosition={logoPosition} logoColor={logoColor} />
      </div>

      <div className={styles.children}>{children}</div>
    </div>
  );
};

export default MainContainerLeftControl;
